
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { CategoryModel } from "@/models/CategoryModel";
import { getModule } from "vuex-module-decorators";
import ContentModule from "../../../store/modules/ContentModule";
import TopicList from "@/components/TopicList/TopicList.vue";
import { Helpers } from "@/global-scripts/helpers";
import { TopicModel } from "@/models/TopicModel";
import AddToPrintButton from "@/components/AddToPrintButton/AddToPrintButton.vue";

@Component({
  components: {
    TopicList,
    SubCategoryList,
    AddToPrintButton,
  },
})
export default class SubCategoryList extends Vue {
  contentModule = getModule(ContentModule, this.$store);

  @Prop()
  topId!: string;

  @Prop()
  parent!: CategoryModel;

  @Prop()
  data!: CategoryModel;

  @Prop({ default: false })
  filterable!: boolean;

  @Prop({ default: 1 })
  level!: number;

  get parentData(): CategoryModel | undefined {
    return this.parent;
  }

  onClick(topic: TopicModel) {
    this.$emit("click", topic);
  }

  getSubCategoryClasses(category: CategoryModel): string {
    const classes = [];
    const numVisible = category.topics ? category.topics.length : 0;

    if (numVisible === 0) {
      classes.push("filtered-out");
    } else if (category.filtered) {
      classes.push("filtered-in");
    } else if (category.filtered === false) {
      classes.push("filtered-out");
    }

    return classes.join(" ");
  }

  urlFriendlyName(category: CategoryModel): string {
    return Helpers.urlFriendlyName(category.title);
  }

  categoriesWithTopics(categories: CategoryModel[]): CategoryModel[] {
    return categories ? categories.filter((c) => this.$validityHelper.categoryHasTopics(c)) : [];
  }

  /**
   * Checks if current category has any immediate topics (not topics in sub categories)
   */
  hasCategoryOwnTopics(category: CategoryModel): boolean {
    return true; // Always return true for now (keeps the sub category header displayed)

    //if (category.hasOwnProperty("topics")) {
    //  return this.filteredTopics(category.topics).length
    //}
  }
}
